<template>
  <div class="w-full">
    <div class="homerBanner">

    </div>
    <!-- 主视觉区域 (Hero Section) -->

    <!-- 系统介绍区域 -->
    <div class="system-intro bg-[#0C3D8E] w-full py-8 sm:py-12 md:py-16 lg:py-20">
      <div class="max-w-[1200px] mx-auto px-4 sm:px-8 md:px-12 lg:px-16">
        <div class="flex flex-col items-center justify-center text-center">
          <img
            src="../../assets/img/board_white.webp"
            alt="product-intro"
            class="pb-6 sm:pb-8 md:pb-10 lg:pb-[46px] w-full max-w-[100px] sm:max-w-[122px] md:max-w-[144px] lg:max-w-[265px]"
          >
          <p class="text-white text-[14px] sm:text-[18px] md:text-[20px] lg:text-[24px] xl:text-[18px] leading-relaxed max-w-[1000px] scroll-fade-in">
            我们针对市面多样的片源与眼镜设备,进行整合规划并开发出一整套播控系统。该系统可实现不同眼镜的互联互通,同时对片源进行全面监管;集成票务系统、硬件管理及片源管理功能,形成一体化操作体系,大幅提升运营效率与管控能力。
          </p>
        </div>
      </div>
    </div>

    <!-- 功能特点区域 -->
    <div class="features bg-[#0C3D8E] w-full pb-12 sm:pb-16 md:pb-20 lg:pb-[112px]">
      <div class="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8">
        <div class="grid grid-cols-1 lg:flex lg:flex-row lg:items-center lg:justify-center gap-4 sm:gap-6 md:gap-8 
        lg:gap-[81px] lg:flex-wrap">
          <div
            v-for="(item, index) in featureCards"
            :key="index"
            class="w-full lg:flex-1 lg:min-w-[250px] lg:max-w-[362px] sm:min-w-[250px] pt-[30px] sm:pt-[40px] md:pt-[50px] lg:pt-[64px] sm:max-w-[362px] bg-white rounded-2xl sm:rounded-3xl pl-[38px] pb-[30px] sm:p-8 scroll-fade-in"
          >
            <div class="flex flex-col items-center">
              <img
                :src="item.image"
                :alt="item.title"
                :class="item.imageClass"
                class="mb-6 sm:mb-8 md:mb-[52px]"
              >
            </div>
            <div class="text-[#07409D] text-lg sm:text-xl md:text-[20px] lg:text-[22px] xl:text-[24px] font-bold">
              {{ item.title }}
            </div>
            <p class="text-[#07409D] text-base sm:text-lg md:text-[20px] lg:text-[22px] xl:text-[24px] font-bold">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 多端管控区域 -->
    <div class="multi-device-control bg-[#FEFEFE] w-full py-8 sm:py-12 md:py-16">
      <div class="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8 pb-12 sm:pb-16 md:pb-20 lg:pb-[40px]">
        <!-- 标题区域 -->
        <div class="flex flex-col items-center justify-center text-center mb-8 sm:mb-12 md:mb-16 lg:mb-[58px]">
          <img
            src="../../assets/img/mult.webp"
            alt="mult"
            class="pb-6 sm:pb-8 md:pb-10 lg:pb-[46px] w-full max-w-[100px] sm:max-w-[122px] md:max-w-[144px] lg:max-w-[265px]"
          >
          <p class="text-[#333333] text-base sm:text-lg md:text-xl lg:text-[24px] leading-relaxed max-w-[1000px] px-4 scroll-fade-in">
            多端协同管控,覆盖全场景运营需求 <br class="hidden sm:block" /> 三端数据实时互通,让VR亲子/LBE场馆运营高效、便捷、无死角。
          </p>
        </div>

        <!-- 内容区域 -->
        <div class="flex flex-col gap-8 sm:gap-12 md:gap-16">
          <!-- 第一个：网页端 - 图左文右 -->
          <div class="flex flex-col md:flex-row items-center gap-6 sm:gap-8 md:gap-12">
            <!-- 左侧：电脑显示器图片占位 -->
            <div class="w-full md:flex-1 md:min-w-[400px] scroll-fade-in-left flex justify-center">
              <img
                src="../../assets/img/iMac-1.webp"
                alt="web"
                class="w-full max-w-[300px] sm:max-w-[350px] md:w-[415px] md:h-[370px] h-auto object-contain"
              >
            </div>
            <!-- 右侧：文字描述 -->
            <div class="w-full md:flex-1 md:min-w-[400px] scroll-fade-in">
              <p class="text-[#333333] text-base sm:text-lg md:text-xl lg:text-[24px] leading-relaxed text-center md:text-left">
                网页端聚焦数据统筹管理,实时同步设备状态、播放数据与运营报表,远程掌控场馆全局;
              </p>
            </div>
          </div>

          <!-- 第二个：PC端 - 图右文左 -->
          <div class="flex flex-col md:flex-row items-center gap-6 sm:gap-8 md:gap-12">
            <!-- 左侧：文字描述 -->
            <div class="w-full md:flex-1 md:min-w-[400px] scroll-fade-in order-2 md:order-1">
              <p class="text-[#333333] text-base sm:text-lg md:text-xl lg:text-[24px] leading-relaxed text-center md:text-left">
                PC端主打专业播控操作,支持内容精准调度、多设备集群联动及场景化方案配置,适配大规模运营场景;
              </p>
            </div>
            <!-- 右侧：笔记本电脑图片占位 -->
            <div class="w-full md:flex-1 md:min-w-[400px] scroll-fade-in-right flex justify-center order-1 md:order-2">
              <img
                src="../../assets/img/iMac-2.webp"
                alt="pc"
                class="w-full max-w-[300px] sm:max-w-[350px] md:w-[415px] md:h-[370px] h-auto object-contain"
              />
            </div>
          </div>
          <!-- 第三个：Pad端 - 图左文右 -->
          <div class="flex flex-col md:flex-row items-center gap-6 sm:gap-8 md:gap-12">
            <!-- 左侧：平板电脑图片占位 -->
            <div class="w-full md:flex-1 md:min-w-[400px] scroll-fade-in-left flex justify-center">
              <img
                src="../../assets/img/pad.webp"
                alt="pad"
                class="w-full max-w-[300px] sm:max-w-[350px] md:w-[413px] md:h-[258px] h-auto object-contain"
              />
            </div>
            <!-- 右侧：文字描述 -->
            <div class="w-full md:flex-1 md:min-w-[400px] scroll-fade-in">
              <p class="text-[#333333] text-base sm:text-lg md:text-xl lg:text-[24px] leading-relaxed text-center md:text-left">
                Pad 端侧重移动灵活管控,随时随地实现内容切换、设备启停与紧急调控,适配场馆巡检、临时运营等高频场景,三端数据实时互通,让 VR 亲子 / LBE场馆运营高效、便捷、无死角。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 场景适配 -->
    <div class="scenario-adaptation bg-[#0C3D8E] w-full py-8 sm:py-12 md:py-16 lg:py-20">
      <div class="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8">
        <!-- 标题区域 -->
        <div class="flex flex-col items-center justify-center text-center mb-8 sm:mb-12 md:mb-16 lg:mb-[68px]">
          <img
            src="../../assets/img/media.webp"
            alt="scenario"
            class="pb-6 sm:pb-8 md:pb-10 lg:pb-[46px] w-full max-w-[100px] sm:max-w-[122px] md:max-w-[144px] lg:max-w-[265px]"
          />
          <p class="text-white text-base sm:text-lg md:text-xl lg:text-[24px] leading-relaxed max-w-[1000px] px-4 scroll-fade-in">
            聚焦 VR 亲子及 LBE 大空间核心运营场景, 提供全维度定制化适配方案, 降低适配成本, 提升运营效率与用户体验。
          </p>
        </div>

        <!-- 内容区域 -->
        <div class="flex flex-col gap-6 sm:gap-8 md:gap-12">
          <!-- 第一个：VR 体验馆 - 图左文右 -->
          <div class="flex flex-col md:flex-row items-stretch relative">
            <!-- 左侧：图片（标题叠加在图片上） -->
            <div class="w-full md:flex-4 md:min-w-[400px] scroll-fade-in-left relative">
              <img
                src="../../assets/img/vr.webp"
                alt="vr"
                class="w-full h-[250px] sm:h-[300px] md:h-[400px] lg:h-[678px] object-cover transition-transform duration-1000 ease-in-out hover:scale-105"
              />
              <!-- 标题叠加在图片上 - 移动端显示在图片底部 -->
              <div
                class="absolute bottom-4 left-4 md:top-[103px] md:bottom-auto md:ml-[70%] z-20 scroll-fade-in w-[calc(100%-2rem)] md:w-[391px] "
                style="background: linear-gradient(to right, #1D76D0 0%, rgba(29, 114, 205, 0) 100%);
                   padding: 7px 0px 5px 31px; border-radius: 46px;"
              >
                <div class="flex items-center gap-3 mb-[3px]">
                  <h3 class="text-white text-2xl sm:text-3xl md:text-3xl lg:text-3xl font-bold">
                    VR 体验馆
                  </h3>
                </div>
                <div class="text-white/90 text-sm sm:text-base md:text-2xl lg:text-2xl">
                  VR EXPERIENCE HALL
                </div>
              </div>
            </div>
            <!-- 右侧：深蓝色遮罩层（只有描述文字） -->
            <div class="w-full md:flex-3 md:min-w-[400px] flex-col croll-fade-in rounded-lg p-6 sm:p-8 flex items-start md:items-end justify-center">

              <div class="w-[51px] h-3 bg-[#10b981] rounded-[51px] mb-6 sm:mb-8 md:mb-[133px]"></div>
              <p class="text-white text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed">
                互动场景, 支持内容按年龄段精准播控、设备低龄化适配管控。
              </p>

            </div>
          </div>
          <!-- 第二个：LBE 大空间 VR 场馆 - 图右文左 -->
          <div class="flex flex-col md:flex-row items-stretch relative md:-mt-[8%] scroll-fade-in-right">
            <!-- 左侧：深蓝色遮罩层（只有描述文字） -->
            <div class="w-full md:flex-3 md:min-w-[400px] scroll-fade-in flex-col rounded-lg p-6 sm:p-8 flex items-start order-2 md:order-1 justify-center">

              <div class="w-[51px] h-3 bg-[#10b981] rounded-[51px] mb-6 sm:mb-8 md:mb-[159px]"></div>
              <p class="text-white text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed">
                支持多设备集群管控、大空间场景内容同步播控, 适配多人互动 VR 游戏的协同播放。
              </p>
            </div>
            <!-- 右侧：图片（标题叠加在图片上） -->
            <div class="w-full md:flex-4 md:min-w-[400px] scroll-fade-in relative order-1 md:order-2">
              <img
                src="../../assets/img/lbedetail.webp"
                alt="lbe"
                class="w-full h-[250px] sm:h-[300px] md:h-[400px] lg:h-[678px] object-cover transition-transform duration-1000 ease-in-out hover:scale-105"
              />
              <!-- 标题叠加在图片上 - 移动端显示在图片底部 -->
              <div
                class="absolute bottom-4 left-4 md:top-[103px] md:bottom-auto md:ml-[-20%] z-20 scroll-fade-in w-[calc(100%-2rem)] md:w-[391px] "
                style="background: linear-gradient(to right, #1D76D0 0%, rgba(29, 114, 205, 0) 100%);
                   padding: 7px 0px 5px 31px; border-radius: 46px;"
              >
                <div class="flex items-center gap-3 mb-[3px]">
                  <h3 class="text-white text-2xl sm:text-3xl md:text-3xl lg:text-3xl  font-bold">
                    LBE 大空间 VR 场馆
                  </h3>
                </div>
                <div class="text-white/90 text-sm sm:text-base md:text-2xl lg:text-2xl">
                  LBE LARGE-SPACE VR VENUE
                </div>
              </div>
            </div>
          </div>

          <!-- 第三个：主题乐园 - 图左文右 -->
          <div class="flex flex-col md:flex-row items-stretch relative md:-mt-[8%] scroll-fade-in-left">
            <!-- 左侧：图片（标题叠加在图片上） -->
            <div class="w-full md:flex-4 md:min-w-[400px] scroll-fade-in relative">
              <img
                src="../../assets/img/theme.webp"
                alt="theme"
                class="w-full h-[250px] sm:h-[300px] md:h-[400px] lg:h-[678px] object-cover transition-transform duration-1000 ease-in-out hover:scale-105"
              />
              <!-- 标题叠加在图片上 - 移动端显示在图片底部 -->
              <div
                class="absolute bottom-4 left-4 md:top-[103px] md:bottom-auto md:left-[87%] md:right-auto w-[calc(100%-2rem)] md:w-[291px] z-20 scroll-fade-in"
                style="background: linear-gradient(to right, #1D76D0 0%, rgba(29, 114, 205, 0) 100%);
                   padding: 7px 0px 5px 31px; border-radius: 46px;"
              >
                <div class="flex items-center gap-3 mb-[3px]">
                  <h3 class="text-white text-2xl sm:text-3xl md:text-3xl lg:text-3xl font-bold">
                    主题乐园
                  </h3>
                </div>
                <div class="text-white/90 text-sm sm:text-base md:text-2xl lg:text-2xl">
                  THEME PARK
                </div>
              </div>
            </div>
            <!-- 右侧：深蓝色遮罩层（只有描述文字） -->
            <div class="w-full md:flex-3 md:min-w-[400px] scroll-fade-in rounded-lg p-6 sm:p-8 flex items-start md:items-end flex-col justify-center z-10">
              <div class="w-[51px] h-3 bg-[#10b981] rounded-[51px] mb-6 sm:mb-8 md:mb-[125px]"></div>
              <p class="text-white text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed">
                融合主题动线设计, 支持不同区域内容差异化播控, 联动乐园运营节奏。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 方案咨询 -->
    <div class="consultation-section relative w-full pt-12 sm:pt-16 md:pt-20 lg:pt-[68px] pb-12 sm:pb-16 md:pb-20 lg:pb-[101px] bg-[#04193B]">
      <div class="max-w-[1200px] mx-auto px-4 sm:px-6 md:px-8">
        <div class="flex flex-col items-center justify-center text-center">
          <img
            src="../../assets/img/solution-c.webp"
            alt="consultation"
            class="mb-6 sm:mb-8 md:mb-10 lg:mb-[46px] w-full max-w-[100px] sm:max-w-[122px] md:max-w-[144px] lg:max-w-[265px]"
          >
          <!-- 描述文字 -->
          <p class="text-white text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed max-w-[800px] mb-8 sm:mb-10 md:mb-12 px-4 scroll-fade-in">
            想让你的 VR 亲子 / LBE 场馆运营效率翻倍？立即咨询获取专属方案
          </p>

          <!-- 立即咨询按钮 -->
          <button
            class="px-6 sm:px-8 md:px-12 lg:px-[50px] py-3 sm:py-4 md:py-5 lg:py-[20px] border-2 border-[#FFFFFF] rounded-xl lg:rounded-[16px] text-[#29FFF8] text-base sm:text-lg md:text-xl lg:text-[36px] font-bold hover:bg-[#0F5A7F] hover:border-[#A8B5D0] transition-all duration-300 scroll-fade-in"
            style="background-color: rgba(11, 224, 187, 0.2);"
            @click="handleConsultation"
          >
            立即咨询&gt;
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from "vue";
import setImg from "@/assets/img/set.webp";
import monitorImg from "@/assets/img/monitor.webp";
import gameImg from "@/assets/img/game.webp";

// 功能卡片数据
interface FeatureCard {
  image: string;
  title: string;
  description: string;
  imageClass: string;
}

const featureCards = ref<FeatureCard[]>([
  {
    image: setImg,
    title: "票务内容管理",
    description: "运营明细",
    imageClass: "w-20 h-20 sm:w-[100px] sm:h-[100px] md:w-[118px] md:h-[118px]",
  },
  {
    image: monitorImg,
    title: "片源内容管控",
    description: "多方位监控",
    imageClass: "w-20 h-20 sm:w-[100px] sm:h-[90px] md:w-[118px] md:h-[102px]",
  },
  {
    image: gameImg,
    title: "设备实时监控部署",
    description: "多硬件适配",
    imageClass: "w-20 h-20 sm:w-[100px] sm:h-[100px] md:w-[118px] md:h-[118px]",
  },
]);

// 爱番番独立沟通链接（PC / 移动端）
const AFFIM_CHAT_URL_PC =
  "https://affim.baidu.com/unique_76738406/chat?siteId=22754352&userId=76738406&siteToken=0d1814da8c0c617ae6ea195eae32d27e";
const AFFIM_CHAT_URL_MOBILE =
  "https://affim.baidu.com/unique_76738406/mobile/chat?siteId=22754352&userId=76738406&siteToken=0d1814da8c0c617ae6ea195eae32d27e";

const handleConsultation = () => {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    window.innerWidth < 768;
  const url = isMobile ? AFFIM_CHAT_URL_MOBILE : AFFIM_CHAT_URL_PC;
  window.open(url, "_blank", "noopener,noreferrer");
};

// 存储已触发动画的元素
const animatedElements = new Set<HTMLElement>();

// Intersection Observer 配置
const observerOptions = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1, // 当元素10%可见时触发
};

// 创建 Intersection Observer
let observer: IntersectionObserver | null = null;

onMounted(() => {
  // 创建 observer
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (
        entry.isIntersecting &&
        !animatedElements.has(entry.target as HTMLElement)
      ) {
        // 元素进入视口且未触发过动画
        const element = entry.target as HTMLElement;
        element.classList.add("fade-in-visible");
        animatedElements.add(element);
      }
    });
  }, observerOptions);

  // 观察所有带有滚动动画类的元素
  const elements = document.querySelectorAll(
    ".scroll-fade-in, .scroll-fade-in-left, .scroll-fade-in-right"
  );
  elements.forEach((element) => {
    if (observer) {
      observer.observe(element);
    }
  });
});

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped lang="scss">
.homerBanner {
  width: 100%;
  height: clamp(156px, 41vw, 1200px);
  background-image: url("../../assets/img/banner_bg.webp");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
// 滚动动画效果 - 小元素从底部飞入
.scroll-fade-in {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

// 滚动动画效果 - 从左边飞入
.scroll-fade-in-left {
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-left.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

// 滚动动画效果 - 从右边飞入
.scroll-fade-in-right {
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-right.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

// 自定义 flex 比例类（用于桌面端布局）
.flex-4 {
  flex: 4;
}

.flex-3 {
  flex: 3;
}

// 响应式设计
@media (max-width: 1200px) {
  .hero-section {
    min-height: 600px;

    > div > div {
      flex-direction: column;
      gap: 4rem;
    }
  }
}

@media (max-width: 768px) {
  .hero-section {
    min-height: auto;
    padding: 2rem 0;

    > div > div > div {
      width: 100% !important;
      max-width: 100%;
    }
  }

  .multi-device-control {
    .flex-row {
      flex-direction: column !important;
    }

    .flex-wrap-reverse {
      flex-direction: column !important;
    }
  }

  .scenario-adaptation {
    .flex-row {
      flex-direction: column !important;
    }

    .flex-wrap-reverse {
      flex-direction: column !important;
    }
  }
}
</style>